let baseUrl = 'https://api.foodi.de'

if (process.env.NODE_ENV === 'development') {
  // baseUrl = 'https://pizzaheinz.test'
}

export default {
  'baseUrl': baseUrl + '/',
  'gettoken': baseUrl + '/api/gettoken',
  'sethost': baseUrl + '/api/sethost/',
  'gethost': baseUrl + '/api/gethost/',
  'menu': baseUrl + '/api/menu/',
  'addproduct': baseUrl + '/api/addProduct/',
  'getBasketById': baseUrl + '/api/getBasketById/',
  'retrieveBasket': baseUrl + '/api/retrieveBasket/',
  'sessionId': baseUrl + '/api/sessionid/',
  'cloneProduct': baseUrl + '/api/cloneProduct',
  'saveCustomerProduct': baseUrl + '/api/saveCustomerProduct',
  'deleteCustomerProduct': baseUrl + '/api/deleteCustomerProduct',
  'removeProduct': baseUrl + '/api/removeProduct',
  'productRules': baseUrl + '/api/productRules',
  'addIngredients': baseUrl + '/api/addIngredients',
  'order': baseUrl + '/api/order',
  'build': baseUrl + '/api/build',
  'availableIngredients': baseUrl + '/api/availableIngredients',
  'addIngredient': baseUrl + '/api/addIngredient',
  'removeIngredient': baseUrl + '/api/removeIngredient',
  'deliveryOptions': baseUrl + '/api/deliveryOptions',
  'geoOptions': baseUrl + '/api/geoOptions',
  'setGeoId': baseUrl + '/api/setGeoId',
  'imprint': baseUrl + '/api/imprint',
  'hostlocations': baseUrl + '/api/hostlocations',
  'hostopen': baseUrl + '/api/hostopen',
  'hostdescription': baseUrl + '/api/hostdescription',
  'hostactive': baseUrl + '/api/hostactive',
  'lastOrder': baseUrl + '/api/lastOrder',
  'locations': baseUrl + '/api/locations',
  'lastlocation': baseUrl + '/api/lastlocation',
  'hosts': baseUrl + '/api/hosts',
  'archivedOrdersCount': baseUrl + '/api/archivedOrdersCount',
  'infos': baseUrl + '/api/infos',
  'ratingDetails': baseUrl + '/api/ratingDetails',
  'ratings': baseUrl + '/api/ratings',
  'ratingsummary': baseUrl + '/api/ratingsummary',
  'gethostbyurl': baseUrl + '/api/gethostbyurl',
  'gethosturlbyid': baseUrl + '/api/gethosturlbyid',
  'archive': baseUrl + '/api/archive',
  'reorder': baseUrl + '/api/reorder',
  'cancel': baseUrl + '/api/cancel',
  'cancelPerRequest': baseUrl + '/api/cancelPerRequest',
  'review': baseUrl + '/api/review',
  'reviewAddImage': baseUrl + '/api/reviewAddImage',
  'redeemCoupon': baseUrl + '/api/redeemCoupon',
  'survey': baseUrl + '/api/survey',
  'surveyComment': baseUrl + '/api/surveyComment',
  'note': baseUrl + '/api/note',
  'removeAiIngredients': baseUrl + '/api/removeAiIngredients',
  'estimateddeliverytime': baseUrl + '/api/estimateddeliverytime',
  'recommend': baseUrl + '/api/recommend',
  'registration': baseUrl + '/api/registration',
  'giropayPay': baseUrl + '/api/giropay',
  'sofortueberweisung': baseUrl + '/api/sofortueberweisung',
  'checkOpenOfficeMaster': baseUrl + '/api/checkopenofficemaster',
  'getpaymentdetailsbyorderid': baseUrl + '/api/getpaymentdetailsbyorderid',
  'stripePaymentIntent': baseUrl + '/api/stripePaymentIntent',
  'updateOrderByUid': baseUrl + '/api/updateOrderByUid',
  'matchHostGeoId': baseUrl + '/api/matchHostGeoId',
  'qrCodeContact': baseUrl + '/api/qrCodeContact',
  'isOfficeOrder': baseUrl + '/api/isOfficeOrder',
  'createOfficeOrder': baseUrl + '/api/createOfficeOrder',
  'joinOfficeOrder': baseUrl + '/api/joinOfficeOrder',
  'cancelOfficeOrderMaster': baseUrl + '/api/cancelOfficeOrderMaster',
  'cancelOfficeOrderClient': baseUrl + '/api/cancelOfficeOrderClient',
  'setOfficeOrderClientName': baseUrl + '/api/setOfficeOrderClientName',
  'officeOrderStatus': baseUrl + '/api/officeOrderStatus',
  'userRegistration': baseUrl + '/api/userRegistration',
  'userActivation': baseUrl + '/api/userActivation',
  'userResendActivationCode': baseUrl + '/api/userResendActivationCode',
  'userLogin': baseUrl + '/api/userLogin',
  'userLogout': baseUrl + '/api/userLogout',
  'userData': baseUrl + '/api/userData',
  'deleteUserLocation': baseUrl + '/api/deleteUserLocation',
  'addOrUpdateUserLocation': baseUrl + '/api/addOrUpdateUserLocation',
  'deleteUser': baseUrl + '/api/deleteUser',
  'userChangePasswd': baseUrl + '/api/userChangePasswd',
  'userUpdateAccount': baseUrl + '/api/userUpdateAccount',
  'userForgotPasswd': baseUrl + '/api/userForgotPasswd',
  'userResetPasswd': baseUrl + '/api/userResetPasswd',
  'userGetC4CBudget': baseUrl + '/api/userGetC4CBudget',
  'legalsBusiness': baseUrl + '/api/legalsBusiness',
  'getCouponForCoupon': baseUrl + '/api/getCouponForCoupon',
  'getOfficeOrderPayPalMeAddress': baseUrl + '/api/getOfficeOrderPayPalMeAddress',
  'pusherAuth': baseUrl + '/api/pusherAuth',
  'getSessionId': baseUrl + '/api/getSessionId',
  'joinHost': baseUrl + '/api/joinHost',
  'leaveHosts': baseUrl + '/api/leaveHosts',
  'joinTable': baseUrl + '/api/joinTable',
  'imprint': baseUrl + '/api/imprintcontent',
  'agb': baseUrl + '/api/agb',
  'privacy': baseUrl + '/api/privacy',
  'businessEmployees': baseUrl + '/api/businessEmployees',
  'businessEmployeesToggleStatus': baseUrl + '/api/businessEmployeesToggleStatus',
  'businessEmployeesRemoveReceiver': baseUrl + '/api/businessEmployeesRemoveReceiver',
  'businessAddReceiver': baseUrl + '/api/businessAddReceiver',
  'businessEditReceiver': baseUrl + '/api/businessEditReceiver',
  'businessCustomerSepa': baseUrl + '/api/businessCustomerSepa',
  'updateBusinessCustomerSepa': baseUrl + '/api/updateBusinessCustomerSepa',
  'paypalcreateOrder': baseUrl + '/paypal2/createOrder',
  'paypalOrders': baseUrl + '/paypal2/orders',
  'paypalCaptureOrder': baseUrl + '/paypal2/captureOrder',
  'paypalCapture': baseUrl + '/paypal2/capture',
  'test': baseUrl + '/api/test'
}



// WEBPACK FOOTER //
// ./src/endpoints.js